import { Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import cardBackgroundImg from '../../../../assets/images/226294.png';
import ColoradoSchoolClassesImg from '../../../../assets/images/shopOurCookingClasses/colorado-school.jpeg';
import IllinoisSchoolClassesImg from '../../../../assets/images/shopOurCookingClasses/illinois-school.jpeg';
import onlineCookingClassesImg from '../../../../assets/images/shopOurCookingClasses/online-cooking-classes.jpeg';
import TexasSchoolClassesImg from '../../../../assets/images/shopOurCookingClasses/texas-school.jpeg';
import './ShopClassCards.css';

interface ClassCard {
  id: string;
  title: string;
  subtitle: string;
  status: string;
  image: string;
  overlayColor: string;
  link: string;
}

const classCards: ClassCard[] = [
  {
    id: 'online',
    title: 'Online Cooking Classes',
    subtitle: 'SPACE AVAILABLE THIS WEEK',
    status: 'available',
    image: onlineCookingClassesImg,
    overlayColor: 'rgba(188, 199, 79, .92)',
    link: '/sessions?session_type=online'
  },
  {
    id: 'school',
    title: 'School Programs',
    subtitle: 'NOW ENROLLING',
    status: 'enrolling',
    image: IllinoisSchoolClassesImg,
    overlayColor: 'rgba(161, 53, 108, .92)',
    link: '/sessions?session_type=after_school'
  },
  {
    id: 'cooking',
    title: 'Cooking Camps',
    subtitle: 'NOW ENROLLING',
    status: 'enrolling',
    image: ColoradoSchoolClassesImg,
    overlayColor: 'rgba(43, 78, 100, .92)',
    link: '/sessions?session_type=camps'
  },
  {
    id: 'events',
    title: 'Events',
    subtitle: 'NOW ENROLLING',
    status: 'enrolling',
    image: TexasSchoolClassesImg,
    overlayColor: 'rgba(211, 97, 60, .92)',
    link: '/sessions?session_type=events'
  }
];

export const ClassCards = () => {
  const navigate = useNavigate();

  const handleShopNow = (link: string) => {
    navigate(link);
  };

  return (
    <Container className="class-cards-container">
      <div className="title-container">
        <h2 className="class-cards-title">Shop Our Cooking Classes</h2>
      </div>

      <div className="class-cards-grid">
        {classCards.map((card) => (
          <div
            className="class-card"
            key={card.id}
            onClick={() => handleShopNow(card.link)}
          >
            <img
              src={card.image}
              alt={card.title}
              className="img-fluid"
            />
            <div
              className="class-card-content"
              style={{
                backgroundImage: `linear-gradient(${card.overlayColor}, ${card.overlayColor}), url(${cardBackgroundImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <div className="card-inner">
                <div className="class-card-status">{card.subtitle}</div>
                <h2 className="class-card-title">{card.title}</h2>
                <Button
                  variant="outline-light"
                  className="class-card-button"
                >
                  SHOP NOW
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};
